import Vue from "vue";
import Vuex from "vuex";
import search from "./modules/search";
import overlay from "./modules/overlay";
import {
  UPDATE_ACTIVE_THREE_SIXTY_COMPONENT,
  UPDATE_ACTIVE_INSTANCE_NAME,
} from "./mutation-types";
import {
  SET_ACTIVE_THREE_SIXTY_COMPONENT,
  SET_ACTIVE_INSTANCE_NAME,
} from "./action-types";

Vue.use( Vuex );

const debug = process.env.NODE_ENV !== "production";

const modules = {
  search,
  overlay,
};

const initialState = {
  LM_THREE_SIXTY: {
    activeComponent: "INITIAL",
    activeInstanceName: "",
  },
};

const mutations = {
  [UPDATE_ACTIVE_THREE_SIXTY_COMPONENT] ( state, activeComponent ) {
    console.log( `LM360 page: ${activeComponent}` );
    state.LM_THREE_SIXTY.activeComponent = activeComponent;
  },
  [UPDATE_ACTIVE_INSTANCE_NAME] ( state, instanceName ) {
    console.log( `Instance name: ${instanceName}` );
    state.LM_THREE_SIXTY.activeInstanceName = instanceName;
  },
};

const getters = {}; // get specific state

const actions = {
  [SET_ACTIVE_THREE_SIXTY_COMPONENT] ( { commit }, activeComponent ) {
    return Promise.resolve( commit( UPDATE_ACTIVE_THREE_SIXTY_COMPONENT, activeComponent ) );
  },
  [SET_ACTIVE_INSTANCE_NAME] ( { commit }, instanceName ) {
    return Promise.resolve( commit( UPDATE_ACTIVE_INSTANCE_NAME, instanceName ) );
  },
};

export default new Vuex.Store( {
  strict: debug,
  state: {
    ...initialState,
  },
  modules,
  mutations,
  getters,
  actions,
} );
